import React, { useRef, useState, useEffect } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import './style.scss';

interface ImageUploadProps {
  onChange?: (file: File | null) => void;
  raito?: string; // Optional prop for aspect ratio, not used in this example
  defaultValue?: string; // Optional prop for default image URL, not used in this example
  isHide?: boolean
}

const ImageUpload: React.FC<ImageUploadProps> = ({ onChange, raito, defaultValue, isHide }) => {
  const [preview, setPreview] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result as string);
      };
      reader.readAsDataURL(file);
      onChange?.(file);
    } else {
      setPreview(null);
      onChange?.(null);
    }
  };

  useEffect(() => {
    if (defaultValue === 'reset') {
      setPreview(null);
    } else {
      setPreview(defaultValue || null); // Set preview to defaultValue if provided
    }
  }, [defaultValue]);

  return (
    <div className='image-upload' style={{ opacity: isHide ? 0 : 1 }}>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileChange}
      />
      <div className='review' style={{ aspectRatio: raito || '1/1' }}>
        {preview && (
          <>
            <div className='clear-img' onClick={() => {
              setPreview(null);
              onChange?.(null);
              if (fileInputRef.current) {
                fileInputRef.current.value = ''; // Clear the file input
              }
            }}><CloseOutlined /></div>
            <img
              src={preview}
              alt="Preview"
            />
          </>
        )}
        {!preview && (
          <div className='upload-placeholder'>
            <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round" strokeLinejoin="round" ><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 8h.01" /><path d="M12.5 21h-6.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6.5" /><path d="M3 16l5 -5c.928 -.893 2.072 -.893 3 0l4 4" /><path d="M14 14l1 -1c.67 -.644 1.45 -.824 2.182 -.54" /><path d="M16 19h6" /><path d="M19 16v6" /></svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageUpload;